import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SystemStatusIndicator = () => {
  const [systemStatus, setSystemStatus] = useState({
    database: { status: 'connected', label: 'قاعدة البيانات', lastCheck: new Date() },
    excelApi: { status: 'connected', label: 'Excel API', lastCheck: new Date() },
    whatsapp: { status: 'connected', label: 'واتساب', lastCheck: new Date() },
    chatgpt: { status: 'connected', label: 'ChatGPT', lastCheck: new Date() },
    googleMaps: { status: 'connected', label: 'خرائط جوجل', lastCheck: new Date() }
  });

  useEffect(() => {
    const checkSystemStatus = () => {
      const statuses = ['connected', 'warning', 'error'];
      const randomStatus = () => statuses?.[Math.floor(Math.random() * statuses?.length)];
      
      setSystemStatus(prev => ({
        database: { ...prev?.database, status: 'connected', lastCheck: new Date() },
        excelApi: { ...prev?.excelApi, status: 'connected', lastCheck: new Date() },
        whatsapp: { ...prev?.whatsapp, status: 'connected', lastCheck: new Date() },
        chatgpt: { ...prev?.chatgpt, status: 'connected', lastCheck: new Date() },
        googleMaps: { ...prev?.googleMaps, status: 'connected', lastCheck: new Date() }
      }));
    };

    const interval = setInterval(checkSystemStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'connected':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected':
        return 'CheckCircle2';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'connected':
        return 'متصل';
      case 'warning':
        return 'تحذير';
      case 'error':
        return 'خطأ';
      default:
        return 'غير معروف';
    }
  };

  return (
    <div className="w-full bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="Activity" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-heading font-semibold text-white">
          حالة الأنظمة المتكاملة
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {Object.entries(systemStatus)?.map(([key, service]) => (
          <div
            key={key}
            className="flex items-center justify-between p-3 bg-muted/50 rounded-lg hover:bg-muted transition-colors"
          >
            <div className="flex items-center gap-3">
              <Icon
                name={getStatusIcon(service?.status)}
                size={18}
                className={getStatusColor(service?.status)}
              />
              <div>
                <p className="text-sm font-medium text-white">{service?.label}</p>
                <p className={`text-xs font-caption ${getStatusColor(service?.status)}`}>
                  {getStatusText(service?.status)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <p className="text-xs text-white/60 text-center font-caption">
          آخر فحص: {new Date()?.toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })}
        </p>
      </div>
    </div>
  );
};

export default SystemStatusIndicator;